//=================================================
//    summary: DCP Lesson Prelude 頁面 -- Hook
//
//    remarks: 000 Tim 2021/11/16 Create
//             001 Tim 2021/12/23 加入 PaintedMe流程
//             002 Tim 2022/11/02 加入 多重登入 阻擋視窗 機制
//             003 Tim 2023/09/07 開啟DCPAssessmentUrl App
//                                不使用 之前 會開下載視窗的流程，改用 開其他App的新流程
//================================================
import React, { useState, useEffect, useRef } from 'react'
import cssPrelude from './Prelude.module.scss'
import './Prelude.css';

import ToolBarTopUnit from '../Tool/ToolBarTopUnit/ToolBarTopUnit.js'
import ToolBarBottomUnit from '../Tool/ToolBarBottomUnit/ToolBarBottomUnit.js'
import OpenWebWindow from '../Tool/OpenWebWindow/OpenWebWindow'
import BCAppsWindows from '../Tool/BCAppsWindows/BCAppsWindows'
import Settings from '../Tool/Settings/Settings'
import Glossary from '../Tool/Glossary/Glossary'
import NoteList from '../Tool/NoteList/NoteList'
import Resource from '../Tool/Resource/Resource'
// import DownloadAnotherAppWindow from '../Tool/DownloadAnotherAppWindow/DownloadAnotherAppWindow'

import Slide from '@material-ui/core/Slide'
import parse from 'html-react-parser'

import {
    LoadingMask, 
    AlertWindow, 
    CredentialMultiInWindow, 
    GlobalLibs, 
    LocalStorageLibs, 
    ClientGatewayInPackage, 
    TimeZoneLibs, 
    RoutePathLibs, 
    PackageVariablesLibs
} from 'bc-react-package'

// #region State Member letiables
let mblnStateChapterListAnimation = false
// #region State Member letiables

// #region Member letiables
let mblnInitialized = false
let mblnIfNeed2GoToApplicationHomePage = null

let marrMenu = []
let marrChapterList = []
let mintTotalChapters = 0
let mintCurrentChapterID = 0
let mstrCurrentSectionID = ""
let mintTmpSectionID = -1
let mintPreludeLastChapterID = -1

let mobjShowComponentParam = null
let mobjAuthorizedSubscription = null

let mobjCurrControls = {
    "AudioSeqNo": -1,
    "AudioPlayer": null
}
let mintLoadedCount = 0
// #endregion Member letiables

// #region Enumeration
const CBTypeEnum = {
    "PreludePlayAudio": 1,
    "TouchAudioArea": 2,
    "PreludePlayVideo": 3,
    "GotoLesson": 4,
    "PreludePlayCustomAudio": 5
}
// #endregion Enumeration


const COMP_NAME = "Prelude"

function Prelude(props)
{
    console.log(COMP_NAME + ".Begin: ", props)

    // #region Init State
    const [updateDataTime, setUpdateDataTime] = useState(0)
    const [toolMenu, setToolMenu] = useState(false)
    const [toolMenuAnimation, setToolMenuAnimation] = useState(false)
    const [chapterListAnimation, setChapterListAnimation] = useState(false)
    const [chaptersIndex, setChaptersIndex] = useState(-1)
    // const [showDownloadAnotherAppWindow, setShowDownloadAnotherAppWindow] = useState(false) // 顯示/隱藏 下載iOS App DCPAssessment

    const [isShowOpenWebWindow, setIsShowOpenWebWindow] = useState(false)
    const [isShowBCAppsWindows, setIsShowBCAppsWindows] = useState(false)
    const [isShowSettings, setIsShowSettings] = useState(false)
    const [isShowGlossary, setIsShowGlossary] = useState(false)
    const [isShowNoteList, setIsShowNoteList] = useState(false)
    const [isShowResource, setIsShowResource] = useState(false)
    
    const [showLoadingMask, setShowLoadingMask] = useState(false)
    const [loadingMaskMessage, setLoadingMaskMessage] = useState("")
    const [showAlert, setShowAlert] = useState(false)
    const [alertObject, setAlertObject] = useState(null)
    const [showCredentialMultiIn, setShowCredentialMultiIn] = useState(false)
    const [credentialMultiInArguments, setCredentialMultiInArguments] = useState(null)
    // #endregion Init State

    // #region Init Ref
    let mrefContent = useRef(null)
    // #endregion Init Ref

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)
    let mrefChangeChaptersIndexAfterProcess = useRef(null)

    mrefPaintedMe.current = PaintedMe
    mrefChangeChaptersIndexAfterProcess.current = ChangeChaptersIndexAfterProcess
    // #endregion Init Function Ref

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + " Init variable")

        mblnInitialized = true
        mblnIfNeed2GoToApplicationHomePage = RoutePathLibs.CheckIfNeed2GoToApplicationHomePage(props.history)
        mintPreludeLastChapterID = LocalStorageLibs.GetAccLSElement('PreludeLastChapterID')
        mobjCurrControls = {
            "AudioSeqNo": -1,
            "AudioPlayer": null
        }
        mintLoadedCount = 0

        console.log(COMP_NAME + ".Begin: mblnIfNeed2GoToApplicationHomePage: ", mblnIfNeed2GoToApplicationHomePage)
        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)
    } // end of if (!mblnInitialized)
    // #endregion First Launch

    // Update toolMenu
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect toolMenu")
        if (toolMenu)
        {
            setToolMenuAnimation(true)
            setChapterListAnimation(true)
        }
    }, [toolMenu])
    
    // Update chaptersIndex
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect chaptersIndex")
        
        if (chaptersIndex !== -1)
        {
            mrefChangeChaptersIndexAfterProcess.current()
        }
    }, [chaptersIndex])

    // Update chapterListAnimation
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect chapterListAnimation")
        mblnStateChapterListAnimation = chapterListAnimation
    }, [chapterListAnimation])

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")
        if (!mblnIfNeed2GoToApplicationHomePage)
        {
            let objWindowRefs = {
                OpenLoadingMask: OpenLoadingMask,
                CloseLoadingMask: CloseLoadingMask,
                ShowAlert: ShowAlert,
                ShowCredentialMultiInWindow: ShowCredentialMultiInWindow
            }
            // AAALibs.RegisterCallerWindownFuncRefs(objWindowRefs)
            GlobalLibs.RegisterCallerWindownFuncRefs(objWindowRefs)
            
            mrefPaintedMe.current()
        }

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")
            if (!mblnIfNeed2GoToApplicationHomePage)
            {
                // AAALibs.UnRegisterCallerWindownFuncRefs()
                GlobalLibs.UnRegisterCallerWindownFuncRefs()
            }

            if (
                (mobjCurrControls.AudioPlayer !== null) &&
                (!mobjCurrControls.AudioPlayer.paused)
                )
            {
                mobjCurrControls.AudioPlayer.pause()
                mobjCurrControls.AudioSeqNo = -1
                mobjCurrControls.AudioPlayer = null
            }

            mblnInitialized = false
            marrMenu = []
            marrChapterList = []
            mintTotalChapters = 0
            mintCurrentChapterID = 0
            mstrCurrentSectionID = ""
            mintTmpSectionID = -1
            mintPreludeLastChapterID = -1
            mobjShowComponentParam = null
            mintLoadedCount = 0

            setToolMenu(false)
            setChapterListAnimation(false)
            setChaptersIndex(-1)

            setIsShowOpenWebWindow(false)
            setIsShowBCAppsWindows(false)

            setIsShowSettings(false)
            setIsShowGlossary(false)
            setIsShowNoteList(false)
            setIsShowResource(false)
            setUpdateDataTime(0)
        }
    }, [props.history])


    // #region OnTapHandler
    /*===========================================
    summary: 點選 Tool按鈕
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function ToolOnTapHandler()
    {
        console.log(COMP_NAME +  ".ToolOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        setToolMenu(true)
    } // end of ToolOnTapHandler

    /*===========================================
    summary: 點選 Mask
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function MaskOnTapHandler()
    {
        console.log(COMP_NAME +  ".MaskOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        setToolMenuAnimation(false)
        setChapterListAnimation(false)
    } // end of MaskOnTapHandler

    /*===========================================
    summary: 點選 工具選單 章節列表元件
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function ChapterUnitOnTapHandler(event)
    {
        console.log(COMP_NAME + ".ChapterUnitOnTapHandler: ", event.target)
        event.preventDefault()
        // e.stopPropagation()
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let objDom = GetParentNodeByClassName(event.target, "divPreludeMenu")
        console.log(COMP_NAME +  ".ChapterUnitOnTapHandler objDom: ", objDom)

        let intChapterID = parseInt(objDom.getAttribute("chapterid"))
        let strSectionID = objDom.getAttribute("sectionid")
        let intSectionID = null

        if (strSectionID !== "")
        {
            intSectionID = parseInt(strSectionID.replace("p", ""))
        }

        console.log(COMP_NAME +  ".ChapterUnitOnTapHandler intChapterID: ", intChapterID)
        console.log(COMP_NAME +  ".ChapterUnitOnTapHandler strSectionID: ", strSectionID)
        console.log(COMP_NAME +  ".ChapterUnitOnTapHandler intSectionID: ", intSectionID)

        setToolMenuAnimation(false)
        setChapterListAnimation(false)

        ChapterSectionChange(intChapterID, intSectionID)
    } // end of ChapterUnitOnTapHandler

    /*===========================================
    summary: 點擊事件 按下
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function ClickOnContentHandler(event)
    {
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        if (event.target.className.indexOf("ClickButton") !== -1)
        {
            ButtonOnClickHandler(event)
        }
        else if (event.target.className.indexOf("BCCustomAudioButton") !== -1)
        {
            BCCustomAudioControlsPlay(event)
        }
    } // end of ClickOnContentHandler

    /*===========================================
    summary: 點選 上一頁
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function PrevOnTapHandler()
    {
        console.log(COMP_NAME +  ".PrevOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        ChapterSectionChange(mintCurrentChapterID - 1, null)
    } // end of PrevOnTapHandler

    /*===========================================
    summary: 點選 下一頁
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function NextOnTapHandler()
    {
        console.log(COMP_NAME +  ".NextOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        ChapterSectionChange(mintCurrentChapterID + 1, null)
    } // end of NextOnTapHandler
    // #endregion OnTapHandler
    
    // #region LoadingMask and Alert Functions
    /*===========================================
    summary: 開啟 讀取中 效果
    remarks: 000 Tim 2021/10/08 Create
    ===========================================*/
    function OpenLoadingMask(LoadingMsg)
    {
        console.log(COMP_NAME + ".OpenLoadingMask")
        setShowLoadingMask(true)
        setLoadingMaskMessage(LoadingMsg)
    } // end of OpenLoadingMask

    /*===========================================
    summary: 關閉 讀取中 效果
    remarks: 000 Tim 2021/10/08 Create
    ===========================================*/
    function CloseLoadingMask()
    {
        console.log(COMP_NAME + ".CloseLoadingMask")
        setShowLoadingMask(false)
        setLoadingMaskMessage("")
    } // end of CloseLoadingMask

    /*===========================================
    summary: 顯示 提示視窗
    remarks: 000 Tim 2021/10/08 Create
    ===========================================*/
    function ShowAlert(AlertObject)
    {
        setAlertObject(AlertObject)
        setShowAlert(true)
    } // end of ShowAlert

    /*===========================================
    summary: 關閉 提示視窗
    remarks: 000 Tim 2021/10/08 Create
    ===========================================*/
    function HideAlert()
    {
        setAlertObject(null)
        setShowAlert(false)
    } // end of HideAlert

    /*===========================================
    summary: 開啟 多重登入 阻擋視窗
    remarks: 000 Tim 2022/11/02 Create
    ===========================================*/
    function ShowCredentialMultiInWindow(Title, Message)
    {
        let objCredentialMultiInArguments = {
            "Title": Title,
            "Message": Message
        }
        setCredentialMultiInArguments(objCredentialMultiInArguments)
        setShowCredentialMultiIn(true)
    } // end of ShowCredentialMultiInWindow
    // #endregion LoadingMask and Alert Functions

    // #region ComponentCallback
    // remarks: 001 Tim 2023/09/07 開啟DCPAssessmentUrl App
    //                             不使用 之前 會開下載視窗的流程，改用 開其他App的新流程
    // function DownloadAnotherAppWindowCallback(CallbackObj)
    // {
    //     console.log(COMP_NAME + ".DownloadAnotherAppWindowCallback CallbackObj: ", CallbackObj)

    //     if (CallbackObj.Action === "CloseDownloadAnotherAppWindow")
    //     {
    //         setShowDownloadAnotherAppWindow(false)
    //     }
    // }

    /*===========================================
    summary: Component 的 Callback
    remarks: 000 Tim 2021/11/03 Create
             001 Tim 2022/08/09 註解 App 取得資料 流程
    ===========================================*/
    function ComponentCallback(CallbackObj)
    {
        console.log(COMP_NAME + ".ComponentCallback CallbackObj: ", CallbackObj)

        if (CallbackObj.Action === "OpenLoadingMask")
        {
            OpenLoadingMask(CallbackObj.Message)
        }
        else if (CallbackObj.Action === "CloseLoadingMask")
        {
            CloseLoadingMask()
        }
        else if (CallbackObj.Action === "ShowAlertWindow")
        {
            ShowAlert(CallbackObj.AlertObject)
        }
        else if (CallbackObj.Action === "ChapterListOnTap")
        {
            setChapterListAnimation(!mblnStateChapterListAnimation)
        }
        else if (CallbackObj.Action === "WillUnmount")
        {
            setToolMenu(false)
        }

        // ====== ToolBarBottomUnit BEGIN ======
        else if (CallbackObj.Action === "AssessmentsOnTap")
        {
            setToolMenu(false)
            GoToAssessments()
        }
        else if (CallbackObj.Action === "BCAppsOnTap")
        {
            setToolMenu(false)
            GoToBCApps()
        }
        else if (CallbackObj.Action === "HelpOnTap")
        {
            setToolMenu(false)
            GoToHelp()
        } 
        else if (CallbackObj.Action === "OpenShowSettings")
        {
            mobjShowComponentParam = {
                "AuthorizedSubscription": null
            }
            setToolMenu(false)
            setIsShowSettings(true)
        }
        else if (CallbackObj.Action === "OpenShowGlossary")
        {
            setToolMenu(false)
            
            // // 準備移除 App 取得資料 流程   Tim22.08.09
            // if (window.gSession.App.InApp)
            // {
            //     GetGlossaryFromAppProcessBegin(window.gSession.App.BookCatID)
            // }
            // else
            // {
                setIsShowGlossary(true)
            // }
        }
        else if (CallbackObj.Action === "OpenShowNoteList")
        {
            mobjShowComponentParam = null
            setToolMenu(false)
            setIsShowNoteList(true)
        }
        else if (CallbackObj.Action === "OpenShowResource")
        {
            mobjShowComponentParam = null
            setToolMenu(false)
            setIsShowResource(true)
        }
        // ====== ToolBarBottomUnit END ======

        else if (CallbackObj.Action === "CloseShowOpenWebWindow")
        {
            mobjShowComponentParam = null
            setIsShowOpenWebWindow(false)
        }
        else if (CallbackObj.Action === "CloseShowBCAppsWindows")
        {
            setIsShowBCAppsWindows(false)
        }
        else if (CallbackObj.Action === "CloseShowSettings")
        {
            mobjShowComponentParam = null
            setIsShowSettings(false)

            // CallbackObj.SettingsDirty = {
            //     // "ProfileEdit": false,
            //     // "PasswordChang": false,
            //     // "SubscriptionUpdate": false,
            //     "LangChange": false
            // }
            if (CallbackObj.SettingsDirty.LangChange)
            {
                // 重新讀取 PreludeData     Tim21.12.22
                LangChangeReGetPreludeDataBegin()
            }
        }
        else if (CallbackObj.Action === "GoToLearningUnit4Settings")
        {
            mobjShowComponentParam = null
            setIsShowSettings(false)

            GotoLearningUnit(CallbackObj.LocationState.BookSeqNo
                , CallbackObj.LocationState.LessonID
                , CallbackObj.LocationState.LUCatSeqNo) 
        }
        else if (CallbackObj.Action === "OpenShowResource4NoAuthorized")
        {
            mobjShowComponentParam = null
            setToolMenu(false)
            setIsShowSettings(false)
            setIsShowResource(true)
        }
        else if (CallbackObj.Action === "CloseShowGlossary")
        {
            mobjShowComponentParam = null
            setIsShowGlossary(false)
        }
        else if (CallbackObj.Action === "CloseShowNoteList")
        {
            mobjShowComponentParam = null
            setIsShowNoteList(false)
        }
        else if (CallbackObj.Action === "CloseShowResource")
        {
            mobjShowComponentParam = null
            setIsShowResource(false)
        }
        else if (CallbackObj.Action === "OpenSettings4NoAuthorized")
        {
            mobjShowComponentParam = {
                "AuthorizedSubscription": CallbackObj.AuthorizedSubscription
            }
            setIsShowSettings(true)
            setIsShowGlossary(false)
            setIsShowNoteList(false)
            setIsShowResource(false)
        }
    } // end of ComponentCallback
    // #endregion ComponentCallback

    // #region Alert Call Back
    /*===========================================
    summary: 點選 Lessons 沒有授權 直接開授權頁面
    remarks: 000 Tim 2021/11/29 Create
    ===========================================*/
    function NoAuthorizedGoToSubscriptionAlertCallBack (BtnObject)
    {
        console.log(COMP_NAME + ".NoAuthorizedGoToSubscriptionAlertCallBack: BtnObject: ", BtnObject)

        if (BtnObject.index === 1) // BTN_OK
        {
            // 改用新的方法開
            mobjShowComponentParam = {
                "AuthorizedSubscription": mobjAuthorizedSubscription
            }
            setIsShowSettings(true)
        }
        else
        {
            // 取消的話，清空資料
            mobjAuthorizedSubscription = null
        }
    } // end of NoAuthorizedGoToSubscriptionAlertCallBack
    // #endregion Alert Call Back

    // #region Other Functions
    /*===========================================
    summary: componentDidMount 程式進入 處理Props資料
    remarks: 000 Tim 2021/12/23 Create
    ===========================================*/
    function PaintedMe()
    {
        console.log(COMP_NAME + ".PaintedMe")

        GetPreludeDataBegin()
    } // end of PaintedMe

    /*===========================================
    summary: 取得 Prelude 資料 開始
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function GetPreludeDataBegin()
    {
        console.log(COMP_NAME + ".GetPreludeDataBegin")

        let strLoadMaskMsg = window.gAppUI.MSG_LoadMask_LoadIntroduction
        OpenLoadingMask(strLoadMaskMsg)
        
        // Note
        // 1. init Menu (synchrously)
        // 2. set total number of Chapter
        // 3. init Chapter List object
        LoadMenuObject()
        mintTotalChapters = marrMenu.length
        LoadChapterListObject()
    } // end of GetPreludeDataBegin

    /*===========================================
    summary: 取得 Prelude 資料 結束
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function GetPreludeDataEnd()
    {
        console.log(COMP_NAME + ".GetPreludeDataEnd")

        CloseLoadingMask()
            
        InitPreludeList()

        setUpdateDataTime(new Date().getTime())
    } // end of GetPreludeDataEnd

    /*===========================================
    summary: 重新取得 Prelude Html資料 開始
    remarks: 000 Tim 2021/12/22 Create
    ===========================================*/
    function LangChangeReGetPreludeDataBegin()
    {
        console.log(COMP_NAME + ".LangChangeReGetPreludeDataBegin")

        let strLoadMaskMsg = window.gAppUI.MSG_LoadMask_LoadIntroduction
        OpenLoadingMask(strLoadMaskMsg)
        
        // init Chapter List object
        LoadChapterListObject()
    } // end of LangChangeReGetPreludeDataBegin

    /*===========================================
    summary: 讀取 Menu JSON
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function LoadMenuObject()
    {
        marrMenu = window.gobjPreludeMenu.Ver_Current

        console.log(COMP_NAME + ".LoadMenuObject marrMenu: ", marrMenu)
    }  // end of LoadMenuObject

    /*===========================================
    summary: 讀取 Html 資訊
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function LoadChapterListObject()
    {
        // 抓所有Chapter內容
        let intIndex = 0
        let intCount = mintTotalChapters
        let objChapter = null
        let strChapterFileName = ''
        let strUrl = ''
        
        console.log(COMP_NAME + ".LoadChapterListObject Preferences: ", window.gSession.Acc.Preferences)
        console.log(COMP_NAME + ".LoadChapterListObject Preferences.Lang: ", window.gSession.Acc.Preferences.Lang)

        // get all chapters (html files)
        for (intIndex = 0; intIndex < intCount; intIndex++)
        { 
            objChapter = marrMenu[intIndex]
            strChapterFileName = (window.gSession.Acc.Preferences.Lang === 1) ? objChapter.MajorFileName : objChapter.MinorFileName

            let xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                // console.log(COMP_NAME + ".LoadChapterListObject this.readyState: ", this.readyState)
                // console.log(COMP_NAME + ".LoadChapterListObject this.status: ", this.status)
                // console.log(COMP_NAME + ".LoadChapterListObject this.responseText: ", this.responseText)
                // console.log(COMP_NAME + ".LoadChapterListObject this: ", this)
                if (
                        // Web
                        (
                            (!window.gSession.App.InApp) &&
                            (this.readyState === 4) && 
                            (this.status === 200)
                        ) ||
                        // App
                        (
                            (window.gSession.App.InApp) &&
                            (this.readyState === 4) && 
                            (this.status === 0)     // 0 代表本地響應成功       Tim20.11.16
                                                    // 應該是xmlhttp自己在模擬，因為根本就沒通過伺服器。本地直接打開而已。OPENED了，所以status為0。  原文網址：https://kknews.cc/code/4z4a6ax.html
                        )
                    ) 
                {
                    console.log(COMP_NAME + ".LoadChapterListObject xhttp Callback: responseText: ", this.responseText)
                    
                    SetPreludeData(this.responseText, this.Index)
                }
            } // end of xhttp.onreadystatechange

            strUrl = "./Prelude/" + strChapterFileName

            console.log(COMP_NAME + ".LoadChapterListObject strUrl: ", strUrl)
            xhttp.open("GET", strUrl, true)
            xhttp.Index = intIndex
            xhttp.async = false         // 同步操作
            xhttp.send()
        } // end of for (intIndex = 0;

        console.log(COMP_NAME + ".LoadChapterListObject marrChapterList: ", marrChapterList)
    }  // end of LoadChapterListObject

    /*===========================================
    summary: 設定 讀到檔案的 資料
    remarks: 000 Tim 2021/12/23 Create
    ===========================================*/
    function SetPreludeData(ResponseText, LoadedIndex)
    {
        console.log(COMP_NAME + ".SetPreludeData")

        marrChapterList[LoadedIndex] = ResponseText
        mintLoadedCount++

        if (mintLoadedCount >= mintTotalChapters)
        {
            console.log(COMP_NAME + ".SetPreludeData marrChapterList: ", marrChapterList)
            GetPreludeDataEnd()
        }
    } // end of SetPreludeData

    /*===========================================
    summary: 初始化 Prelude
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function InitPreludeList()
    {
        console.log(COMP_NAME + ".InitPreludeList")

        // init Chapter from LS or null: chapter 1
        ChapterSectionChange(mintPreludeLastChapterID, null)

        // this.OpenMenu();
    } // end of InitPreludeList

    /*===========================================
    summary: 切換到某一章 或 某一節
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/  
    function ChapterSectionChange(ToChapterID, ToSectionID)
    {
        let intToChapterIndex = ToChapterID - 1

        console.log("ToChapterID: ", ToChapterID)
        console.log("mintCurrentChapterID: ", mintCurrentChapterID)

        if (
            (ToSectionID !== null) && 
            (ToSectionID !== "")
            )
        {
            mintTmpSectionID = ToSectionID
        }
        else
        {
            mintTmpSectionID = -1
        }

        if (ToChapterID !== mintCurrentChapterID)
        {
            console.log("ToChapterID: ", ToChapterID)

            // set current ID
            mintCurrentChapterID = ToChapterID

            setChaptersIndex(intToChapterIndex)

            // set LocaStorage (Chapter prefernce)
            LocalStorageLibs.SetAccLSElement('PreludeLastChapterID', ToChapterID)
        }
        else
        {
            // in the same Chapter
            if (mintTmpSectionID === -1)
            {
                // scroll to 0
                ScrollToChapterTop()

                // set current ID
                mstrCurrentSectionID = ""
            }
            else
            {
                if (mintTmpSectionID !== mstrCurrentSectionID)
                {
                    // set current ID
                    mstrCurrentSectionID = mintTmpSectionID
                }
                ScrollToSection(mintTmpSectionID)
            }
        }
    }  // end of ChapterSectionChange

    /*===========================================
    summary: 改變 章節 Index After Process
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function ChangeChaptersIndexAfterProcess() 
    {
        console.log(COMP_NAME + ".ChangeChaptersIndexAfterProcess")
        // 先顯示完畫面，再去做滾動     Tim20.11.16

        // to section?
        if (mintTmpSectionID !== -1)
        {
            // go to this section
            if (mrefContent.current !== null)
            {
                mrefContent.current.scroll({
                    top: 0,
                    left: 0
                });
                setTimeout(function(){ 
                    ScrollToSection(mintTmpSectionID)
                }, 200)  
            } // end of if (mrefContent.current !== null)

            // set current ID
            mstrCurrentSectionID = mintTmpSectionID
        }
        else
        {
            // scroll to 0
            ScrollToChapterTop()
            mstrCurrentSectionID = ""
        }
    }  // end of ChangeChaptersIndexAfterProcess

    /*===========================================
    summary: 滾到章節最上位
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function ScrollToChapterTop()
    {
        if (mrefContent.current !== null)
        {
            mrefContent.current.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth'
            })
        } // end of if (mrefContent.current !== null)
    } // end of ScrollToChapterTop

    /*===========================================
    summary: 滾到章節某一節
    remarks: 000 Tim 2020/11/13 Create
    ===========================================*/
    function ScrollToSection(SectionID)
    {
        console.log(COMP_NAME + ".ScrollToSection SectionID: ", SectionID)

        if (mrefContent.current !== null)
        {
            let objDom = mrefContent.current.querySelector("#p" + SectionID)
            console.log(COMP_NAME + ".ScrollToSection objDom: ", objDom)

            console.log(COMP_NAME + ".ScrollToSection scroll: ", mrefContent.current.scroll)

            if (objDom !== null)
            {
                console.log(COMP_NAME + ".ScrollToSection objDom.offsetTop: ", objDom.offsetTop)
                // let intMaxY = this.getCtnContent().getScrollable().getScroller().maxPosition.y
                // if (intOffsetDistance > intMaxY)
                // {
                //     intOffsetDistance = intMaxY
                // }

                // 目前 Safari不支援 動畫滾動，會直接跳到 該座標      Tim20.11.16
                mrefContent.current.scroll({
                    top: objDom.offsetTop,
                    left: 0,
                    behavior: 'smooth'
                })
            }
            else
            {
                mrefContent.current.scroll({
                    top: 0,
                    left: 0
                })
            }
        } // end of if (mrefContent.current !== null)
    } // end of ScrollToSection

    /*===========================================
    summary: 轉換選單列表格式為顯示的格式
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function GenerateFlattedMenuList4Display (MenuList)
    {
        let arrMenu = []
        let objItem = {}

        let intChapterIndex = 0
        let intChapterCount = MenuList.length
        let intSectionIndex = 0
        let intSectionCount = 0

        let objChapter = null
        let objSection = null

        for (intChapterIndex = 0; intChapterIndex < intChapterCount; intChapterIndex++)
        {
            objChapter = MenuList[intChapterIndex]
            intSectionCount = objChapter.SectionList.length

            // Chapter data
            objItem = {
                "Type": 1,                          // 1: I am a Chapter
                "ChapterID": objChapter.ChapterID,
                "SectionID": "",
                "Name": objChapter.Name
            }
            arrMenu.push(objItem)

            // section data
            for (intSectionIndex = 0; intSectionIndex < intSectionCount; intSectionIndex++)
            {
                objSection = objChapter.SectionList[intSectionIndex]
    
                // Section data
                objItem = {
                    "Type": 2,                          // 2: I am a Section
                    "ChapterID": objChapter.ChapterID,
                    "SectionID": objSection.SectionID,
                    "Name": objSection.Name
                }    
                arrMenu.push(objItem)
            } // end of for (intSectionIndex = 0;
        } // end of for (intChapterIndex = 0;

        return arrMenu
    } // end of GenerateFlattedMenuList4Display
    
    /*===========================================
    summary: 取得 章節元件 Cls
    remarks: 000 Tim 2021/11/16 Create
             001 Tim 2022/08/09 註解 App 取得資料 流程
    ===========================================*/
    function GetContentHtml(StateChaptersIndex) 
    {
        console.log(COMP_NAME + ".GetContentHtml StateChaptersIndex: ", StateChaptersIndex)
        console.log(COMP_NAME + ".GetContentHtml marrChapterList: ", marrChapterList)
        

        // different Chapter
        let strHtml = marrChapterList[StateChaptersIndex]
        let strFilePrefix = ''

        console.log(COMP_NAME + ".GetContentHtml strHtml: ", strHtml)

        // // 準備移除 App 取得資料 流程   Tim22.08.09
        // if (window.gSession.App.InApp)
        // {
        //     strFilePrefix = '../' + window.gSession.App.PreludeRelativeUrl
        // }
        // else
        // {
            strFilePrefix = window.gConfig.PreludeUrl + window.gSession.App.PreludePrefix
        // }

        // 置換 圖片路徑
        strHtml = strHtml.replace(/resources\/prelude/g, strFilePrefix)

        // 將 image路徑 增加版號 解決圖片暫存問題  Tim15.03.31
        strHtml = strHtml.replace(/.png/g, ".png" + window.gConst.IMG_VER_POSTFIX + process.env.REACT_APP_LOG_VERSION)
            
        if (window.gSession.App.InApp)
        {
            strHtml = strHtml.replace(/onclick/g, "ontouchstart")
        }

        strHtml = strHtml.replace(/\s{2,}/g, ' ')
        strHtml = strHtml.replace(/\t/g, ' ')
        strHtml = strHtml.toString().trim().replace(/(\r\n|\n|\r)/g,"")
        strHtml = strHtml.replace(/> </g, '><')

        return strHtml
    } // end of GetContentHtml

    /*===========================================
    summary: 內容 按鈕按下 
    remarks: 000 Tim 2020/11/13 Create
    ===========================================*/
    function ButtonOnClickHandler(event)
    {
        console.log(COMP_NAME + ".ButtonOnClickHandler: ", event)

        console.log("ButtonOnClickHandler event.target: ", event.target)

        let intType = parseInt(event.target.getAttribute('Type'))
        console.log("ButtonOnClickHandler intType:", intType)

        let strUrl = ""
        let intBookSeqNo = 0
        let intLessonId = 0
        let intLUID = 0

        switch (intType)
        {
            case CBTypeEnum.PreludePlayAudio:
                strUrl = event.target.getAttribute('AudioUrl')
                PreludePlayAudio(strUrl)
                break
            case CBTypeEnum.TouchAudioArea:
                TouchAudioArea(event)
                break
            case CBTypeEnum.PreludePlayVideo:
                PreludePlayVideo(event)
                break
            case CBTypeEnum.GotoLesson:
                intBookSeqNo = parseInt(event.target.getAttribute('BookSeqNo'))
                // console.log("ButtonOnClickHandler: intBookSeqNo:", intBookSeqNo)
                intLessonId = parseInt(event.target.getAttribute('LessonId'))
                intLUID = parseInt(event.target.getAttribute('LUID'))
                GotoLessonProcess(intBookSeqNo, intLessonId, intLUID)
                break
            default:
                break
        } // end of switch (intType)
    } // end of ButtonOnClickHandler

    // ============ 原Prelude Function BEGIN ============
    /*===========================================
    summary: 原Prelude Function Audio 進度條 按下播放
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function BCCustomAudioControlsPlay(event)
    {
        console.log(COMP_NAME + ".BCCustomAudioControlsPlay: ", event.target);

        let objBCCustomAudio = event.target.parentNode.parentNode.parentNode
        let objAudioPlayer = objBCCustomAudio.getElementsByTagName("audio")[0]
        let objLetIsPlayed = objBCCustomAudio.getElementsByClassName("BCCustomAudioVariables")[0].getElementsByClassName("IsPlayed")[0]
        let intAudioSeqNo = parseInt(objAudioPlayer.getAttribute("AudioSeqNo"))

        console.log("BCCustomAudioControlsPlay objBCCustomAudio: ", objBCCustomAudio)
        console.log("BCCustomAudioControlsPlay objAudioPlayer: ", objAudioPlayer)
        console.log("BCCustomAudioControlsPlay objLetIsPlayed: ", objLetIsPlayed)
        console.log("BCCustomAudioControlsPlay intAudioSeqNo: ", intAudioSeqNo)

        if (
            (mobjCurrControls.AudioPlayer !== null) &&
            (mobjCurrControls.AudioSeqNo !== intAudioSeqNo) &&
            (!mobjCurrControls.AudioPlayer.paused)
            )
        {
            mobjCurrControls.AudioPlayer.pause()
            mobjCurrControls.AudioSeqNo = -1
            mobjCurrControls.AudioPlayer = null
        }

        if (objAudioPlayer.paused)
        {
            objAudioPlayer.play()
            event.target.className = event.target.className.replace("PlayIcon", "PauseIcon")

            if (objLetIsPlayed.innerHTML.trim().toLowerCase() === "false")
            {
                objLetIsPlayed.innerHTML = "true"
            }

            mobjCurrControls.AudioSeqNo = intAudioSeqNo
            mobjCurrControls.AudioPlayer = objAudioPlayer
        }
        else
        {
            objAudioPlayer.pause()
            event.target.className = event.target.className.replace("PauseIcon", "PlayIcon")
        }
    } // end of BCCustomAudioControlsPlay

    /*===========================================
    summary: 原Prelude Function Audio CanPlay事件
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function BCCustomAudioCanPlay(event)
    {
        console.log(COMP_NAME + ".BCCustomAudioCanPlay: ", event)

        if (event.target.parentNode.className.indexOf("BCCustomAudioBody") === -1)
        {
            return
        }

        let intDurationSec = Math.floor(event.target.duration)
        let intDurationMin = 0
        let strDurationSec = ""
        let strDurationMin = ""

        let objBCCustomAudio = event.target.parentNode.parentNode

        if (intDurationSec >= 60)
        {
            intDurationMin = Math.floor(intDurationSec / 60)
        }
        intDurationSec = intDurationSec % 60

        strDurationSec = intDurationSec.toString().PadLeft(2)
        strDurationMin = intDurationMin.toString().PadLeft(2)

        objBCCustomAudio.getElementsByClassName("BCCustomAudioPlayedTime")[0].innerHTML = "00:00"
        objBCCustomAudio.getElementsByClassName("BCCustomAudioRemainingTime")[0].innerHTML = "-" + strDurationMin + ":" + strDurationSec
    } // end of BCCustomAudioCanPlay

    /*===========================================
    summary: 原Prelude Function Audio Time Change事件
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function BCCustomAudioTimeChange(event)
    {
        // console.log(COMP_NAME + ".BCCustomAudioTimeChange: ", event)
        if (event.target.parentNode.className.indexOf("BCCustomAudioBody") === -1)
        {
            return
        }

        let intPlayedSec = Math.floor(event.target.currentTime)
        let intDurationSec = Math.floor(event.target.duration)
        let intRemainingSec = intDurationSec - intPlayedSec
        let intPlayedMin = 0
        let intRemainingMin = 0

        let strPlayedSec = ""
        let strPlayedMin = ""
        let strRemainingSec = ""
        let strRemainingMin = ""

        let objBCCustomAudio = event.target.parentNode.parentNode

        if (intPlayedSec >= 60)
        {
            intPlayedMin = Math.floor(intPlayedSec / 60)
        }
        intPlayedSec = intPlayedSec % 60

        if (intRemainingSec >= 60)
        {
            intRemainingMin = Math.floor(intRemainingSec / 60)
        }
        intRemainingSec = intRemainingSec % 60

        // 左邊補零 Format "01"
        strPlayedSec = intPlayedSec.toString().PadLeft(2)
        strPlayedMin = intPlayedMin.toString().PadLeft(2)
        strRemainingSec = intRemainingSec.toString().PadLeft(2)
        strRemainingMin = intRemainingMin.toString().PadLeft(2)

        objBCCustomAudio.getElementsByClassName("BCCustomAudioPlayedTime")[0].innerHTML = "" + strPlayedMin + ":" + strPlayedSec
        objBCCustomAudio.getElementsByClassName("BCCustomAudioRemainingTime")[0].innerHTML = "-" + strRemainingMin + ":" + strRemainingSec
        objBCCustomAudio.getElementsByClassName("BCCustomAudioProgress")[0].value = (event.target.currentTime / event.target.duration) * 100
    } // end of BCCustomAudioTimeChange

    /*===========================================
    summary: 原Prelude Function Audio End事件
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function BCCustomAudioOnEnd(event)
    {
        console.log(COMP_NAME + ".BCCustomAudioOnEnd: ", event)

        if (event.target.parentNode.className.indexOf("BCCustomAudioBody") === -1)
        {
            return
        }

        let objBCCustomAudio = event.target.parentNode.parentNode;
        let objButton = objBCCustomAudio.getElementsByClassName("BCCustomAudioButton")[0]

        if (!event.target.paused)
        {
            objButton.className = objButton.className.replace("PauseIcon", "PlayIcon")
        }

        mobjCurrControls.AudioSeqNo = -1
        mobjCurrControls.AudioPlayer = null
    } // end of BCCustomAudioOnEnd

    /*===========================================
    summary: 原Prelude Function Audio Play事件
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function BCCustomAudioOnPlay(event)
    {
        console.log(COMP_NAME + ".BCCustomAudioOnPlay: ", event)

        if (event.target.parentNode.className.indexOf("BCCustomAudioBody") === -1)
        {
            return
        }

        let objBCCustomAudio = event.target.parentNode.parentNode
        let objButton = objBCCustomAudio.getElementsByClassName("BCCustomAudioButton")[0]

        objButton.className = objButton.className.replace("PlayIcon", "PauseIcon")

        let objLetIsPlayed = objBCCustomAudio.getElementsByClassName("BCCustomAudioVariables")[0].getElementsByClassName("IsPlayed")[0]
        if (objLetIsPlayed.innerHTML.trim().toLowerCase() === "false")
        {
            objLetIsPlayed.innerHTML = "true"
            // objBCCustomAudio.getElementsByClassName("BCCustomAudioSlider")[0].removeAttribute("disabled")
        }
    } // end of BCCustomAudioOnPlay

    /*===========================================
    summary: 原Prelude Function Audio 暫停事件
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function BCCustomAudioOnPause(event)
    {
        console.log(COMP_NAME + ".BCCustomAudioOnPause: ", event)
        if (event.target.parentNode.className.indexOf("BCCustomAudioBody") === -1)
        {
            return
        }

        let objBCCustomAudio = event.target.parentNode.parentNode
        let objButton = objBCCustomAudio.getElementsByClassName("BCCustomAudioButton")[0]

        objButton.className = objButton.className.replace("PauseIcon", "PlayIcon")
    } // end of BCCustomAudioOnPause
    // ============ 原Prelude Function END ============

    // ========== 原 prelude.js Func BEGIN ==========
    /*===========================================
    summary: 播放 聲音檔
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function PreludePlayAudio(AudioFN)
    {
        console.log(COMP_NAME + ".PreludePlayAudio: ", AudioFN)

        let objAudioPlayer = document.getElementById('audioPreludePlayer')

        if (!objAudioPlayer.paused)
        {
            objAudioPlayer.pause()
        }

        objAudioPlayer.src = AudioFN
        objAudioPlayer.play()

        mobjCurrControls.AudioSeqNo = -1
        mobjCurrControls.AudioPlayer = objAudioPlayer
    } // end of PreludePlayAudio

    /*===========================================
    summary: 播放 聲音檔
    remarks: 000 Tim 2021/11/17 Create
             001 Tim 2022/08/09 註解 App 取得資料 流程
    ===========================================*/
    function TouchAudioArea(event)
    {
        console.log(COMP_NAME + ".TouchAudioArea: ", event)

        // event發生在 img 上， 不是在 div 上
        let objBCTouchAreaNode = GetParentNodeByClassName(event.target, "BCTouchAreaMain")
        let objBCTouchAreaDataNode = objBCTouchAreaNode.getElementsByClassName("BCTouchAreaData")[0]

        console.log("objBCTouchAreaNode: ", objBCTouchAreaNode);
        console.log("objBCTouchAreaDataNode: ", objBCTouchAreaDataNode);
        // let objTouchAreaRect = objBCTouchAreaNode.getBoundingClientRect()

        let intTouchX = 0
        let intTouchY = 0
        if (window.gSession.App.InApp)
        {
            console.log("Touch: ", event)
            console.log("objBCTouchAreaNode: ", objBCTouchAreaNode)
            // event.stopPropagation();
            // event.preventDefault();
            
            intTouchX = event.nativeEvent.offsetX
            intTouchY = event.nativeEvent.offsetY
        }
        else
        {
            // mouse
            console.log("mouse: ", event)
            console.log("mouse offsetX: ", event.nativeEvent.offsetX)

            intTouchX = event.nativeEvent.offsetX
            intTouchY = event.nativeEvent.offsetY
            // intTouchX = event.offsetX;
            // intTouchY = event.offsetY;
        }
        
        // console.log("intTouchX: ", intTouchX)
        // console.log("intTouchY: ", intTouchY)

        let intTouchOffsetWidth = event.target.offsetWidth
        let objTouchAreaData = JSON.parse(objBCTouchAreaDataNode.innerHTML)
        let intOriginalTotalWidth = objTouchAreaData.Width
        let blnFound = false
        let intLenghOfArea = objTouchAreaData.Config.length
        let intIndex = 0

        while ((!blnFound) && (intIndex < intLenghOfArea))
        {
            if (IsInArea(intTouchX, intTouchY, intTouchOffsetWidth, objTouchAreaData.Config[intIndex].Area[0], objTouchAreaData.Config[intIndex].Area[1], objTouchAreaData.Config[intIndex].Area[2], objTouchAreaData.Config[intIndex].Area[3], intOriginalTotalWidth))
            {
                let strFilePrefix = window.gConfig.PreludeUrl + window.gSession.App.PreludePrefix

                // // 準備移除 App 取得資料 流程   Tim22.08.09
                // if (window.gSession.App.InApp)
                // {
                //     strFilePrefix = '../' + window.gSession.App.PreludeRelativeUrl + /audio/
                // }
                // else
                // {
                    // 因為 要檔 "FileServerURL": "https://appfs.betterchinese.com/original/", 的存取 IP 讓 使用者 無法下載
                    // Prelude 暫時不擋 改用 PreludeUrl   Tim20.07.08
                    strFilePrefix = window.gConfig.PreludeUrl + window.gSession.App.PreludePrefix + /audio/
                // }

                let strAudioFN = strFilePrefix + objTouchAreaData.Config[intIndex].AudioFN + window.gConst.IMG_VER_POSTFIX + process.env.REACT_APP_LOG_VERSION

                // PreludePlayAudio("resources/prelude/audio/" + objTouchAreaData.Config[i].AudioFN)
                PreludePlayAudio(strAudioFN)
                blnFound = true
            }

            intIndex++
        } // end of while
    } // end of TouchAudioArea

    /*===========================================
    summary: 是否在 區域內
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function IsInArea(EventX, EventY, CurrentTotalWidth, AreaLeft, AreaTop, AreaWidth, AreaHeight, OriginalTotalWidth)
    {
        console.log(COMP_NAME + ".IsInArea: ", EventX, EventY, CurrentTotalWidth, AreaLeft, AreaTop, AreaWidth, AreaHeight, OriginalTotalWidth)
        let blnIn = false
        let fltRatio = OriginalTotalWidth/CurrentTotalWidth
        let fltX = EventX * fltRatio
        let fltY = EventY * fltRatio

        console.log("fltRatio: ", fltRatio)
        console.log("fltX, fltY: ", fltX, fltY)
        console.log("AreaLeft, AreaWidth: ", AreaLeft, AreaWidth)
        console.log("AreaTop, AreaHeight: ", AreaTop, AreaHeight)
        if (
                (
                    (fltX >= AreaLeft) && 
                    (fltX <= AreaLeft + AreaWidth)
                ) && 
                (
                    (fltY >= AreaTop) && 
                    (fltY <= AreaTop + AreaHeight)
                )
            )
        {
            blnIn = true
        }

        console.log("blnIn: ", blnIn)
        return blnIn
    } // end of IsInArea

    /*===========================================
    summary: 播放 影片檔
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function PreludePlayVideo(event)
    {
        console.log(COMP_NAME + ".PreludePlayVideo: ", event);

        let objBCTouchAreaNode = GetParentNodeByClassName(event.target, "VideoContainer")

        let objVideo = objBCTouchAreaNode.getElementsByTagName("video")[0]
        let objVideoCover = objBCTouchAreaNode.getElementsByClassName("VideoCover")[0]
        let objVideoBody = objBCTouchAreaNode.getElementsByClassName("VideoBody")[0]

        // hide cover show body
        objVideoCover.style.display = "none"
        objVideoBody.style.display = "table-cell"

        // play video can open controls
        objVideo.play()
        objVideo.setAttribute("controls", "controls")
    } // end of PreludePlayVideo

    /*===========================================
    summary: 前往 Lesson LU單元
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function GotoLessonProcess(BookSeqNo, LessonID, LUCatSeqNo)
    {
        console.log(COMP_NAME + ".GotoLessonProcess: ", BookSeqNo, LessonID, LUCatSeqNo)

        let strBookSeqNo = BookSeqNo.toString().PadLeft(2)    // 左邊補零 Format "01"

        console.log(COMP_NAME + ".GotoLessonProcess End: ", strBookSeqNo, LessonID, LUCatSeqNo)

        let blnExpired = true
        // 如果他是 該本書 第一個 Lesson，有試用
        if (parseInt(window.gSession.App.BookDef[strBookSeqNo].Lesson[0].ID) === parseInt(LessonID))
        {
            blnExpired = false
        }
        else 
        {
            blnExpired = window.Globals.CheckAuthorized(window.gSession.Acc.AccountAuthorized, window.gSession.App.BookCatID, parseInt(strBookSeqNo))
        }   

        if (!blnExpired)
        {
            console.log("GoToLessonOnTapHandler strBookSeqNo: ", strBookSeqNo)
            console.log("GoToLessonOnTapHandler LessonID: ", LessonID)
            console.log("GoToLessonOnTapHandler LUCatSeqNo: ", LUCatSeqNo)

            GotoLearningUnit(strBookSeqNo, LessonID, LUCatSeqNo)
        }
        else
        {
            console.log("GoToLessonOnTapHandler NoAuthorizedProcess")

            NoAuthorizedProcess(window.gSession.App.BookCatID, strBookSeqNo, LessonID, LUCatSeqNo)
        } // end of if (blnExpired)
    } // end of GotoLessonProcess
    // ========== 原 prelude.js Func END ==========

    /*===========================================
    summary: 前往 Learning Unit 頁面
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function GotoLearningUnit (BookSeqNo, LessonID, LUCatSeqNo)
    {
        console.log(COMP_NAME + ".GotoLearningUnit: ", BookSeqNo, LessonID, LUCatSeqNo)
    
        let strLessonID = LessonID.PadLeft(5)
        let objLocationState = {
            "BookSeqNo": parseInt(BookSeqNo),
            "LessonID": strLessonID,
            "LUCatSeqNo": parseInt(LUCatSeqNo)
        }
        console.log("GotoLearningUnit objLocationState: ", objLocationState)

        RoutePathLibs.Route2Path(props.history, "/Lessons", objLocationState)
    } // end of GotoLearningUnit

    /*===========================================
    summary: 沒有授權 的 後續流程，先走購買，再回到 原本選擇的Lesson
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function NoAuthorizedProcess (BookCatID, BookSeqNo, LessonID, LUCatSeqNo)
    {
        console.log(COMP_NAME + ".NoAuthorizedProcess: Not Authorized!")

        console.log(COMP_NAME + ".NoAuthorizedProcess: BookCatID: ", BookCatID)
        console.log(COMP_NAME + ".NoAuthorizedProcess: BookSeqNo: ", BookSeqNo)
        console.log(COMP_NAME + ".NoAuthorizedProcess: LessonID: ", LessonID)
        console.log(COMP_NAME + ".NoAuthorizedProcess: LUCatSeqNo: ", LUCatSeqNo)

        // 先不串 GoogleClass 配對這塊     Tim20.04.17
        let strBookSeqNo = BookSeqNo.toString().PadLeft(2)
        mobjAuthorizedSubscription = {
            "BookCatID": parseInt(BookCatID),
            "BookSeqNo": strBookSeqNo,
            "LessonID": LessonID,
            "LUCatSeqNo": parseInt(LUCatSeqNo),
            "SubscriptionType": -1
        }
        
        let objAlertObject = {
            Header: "",
            Body: window.gAppUI.ERR_GoToLUNoAuthorizedGoToIAP,
            ShowCloseButton: false,
            CallbackRef: NoAuthorizedGoToSubscriptionAlertCallBack,
            Buttons: [
                {
                    Text: window.gAppUI.BTN_Cancel,
                    AutoFocus: false
                },
                {
                    Text: PackageVariablesLibs.UISettings.BTN_OK,
                    AutoFocus: true
                }
            ]
        }
        ShowAlert(objAlertObject)
    } // end of NoAuthorizedProcess

    /*===========================================
    summary: 前往 Assessments的 連結
    remarks: 000 Tim 2021/11/04 Create
             001 Tim 2023/06/19 處理 AppCallbackRef
             002 Tim 2023/08/18 改寫 ClientGatewayInPackage.CallApp(
                                參數 要改用 最新版本 QueryString, CallbackFuncRef
             003 Tim 2023/09/07 iOSNewGateway 改寫 
                                不使用 之前 會開下載視窗的流程
                                改用 開其他App的新流程
    ===========================================*/
    function GoToAssessments ()
    {
        const FUNC_NAME = GoToAssessments.name
        console.log(COMP_NAME + "." + FUNC_NAME + ": ", window.gSession.Acc.Preferences)

        let strTimeZoneValue = "";
        if (
            (typeof(window.gSession.Acc.Preferences) !== 'undefined') && 
            (window.gSession.Acc.Preferences !== null) &&
            (typeof(window.gSession.Acc.Preferences.TimeZone) !== 'undefined') && 
            (window.gSession.Acc.Preferences.TimeZone !== null) &&
            (window.gSession.Acc.Preferences.TimeZone !== -1)
            )
        {
            strTimeZoneValue = TimeZoneLibs.GetTimeZoneValueByID(window.gSession.Acc.Preferences.TimeZone)
        } // end of if (window.gSession.Acc.Preferences.TimeZone !== -1)
        console.log(COMP_NAME + "." + FUNC_NAME + " strTimeZoneValue: ", strTimeZoneValue)

        let intClassID = -1

        if (
            (window.gSession.Acc.CurrentClassIndex >= 0) &&
            (window.gSession.Acc.Class !== null) &&
            (typeof(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex]) !== 'undefined') &&
            (typeof(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID) !== 'undefined') &&
            (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID) > 0)
            )
        {
            intClassID = parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID)
        } // end of if (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID) > 0)

        if (!window.gSession.App.InApp)
        {
            console.log(COMP_NAME + "." + FUNC_NAME + " not In App")

            // 暫時先用笨解法 轉換環境參數   Tim15.08.19
            let intEnv = GlobalLibs.GetIntEnv(window.gSession.App.Env)

            console.log(COMP_NAME + "." + FUNC_NAME + " Acc.Class: ", window.gSession.Acc.Class)

            // 增加參數 AccountID   Tim16.05.19
            let strQueryString = "Credential=" + window.gSession.Acc.Credential 
            strQueryString += "&BackRoute=" 
            strQueryString += "&ClassName=" + window.gSession.Acc.Profile.ClassName 
            strQueryString += "&LoginName=" + window.gSession.Acc.LoginName 
            strQueryString += "&AccountID=" + window.gSession.Acc.ID
            strQueryString += "&CurrentClassID=" + intClassID
            strQueryString += "&TimeZone=" + strTimeZoneValue
            strQueryString += "&DST=" + window.gSession.Acc.Preferences.DST
            strQueryString += "&lang=" + window.gSession.Acc.Preferences.Lang 
            strQueryString += "&Env=" + intEnv
            
            let strWebSiteUrl = window.gConfig.AssessmentUrl

            mobjShowComponentParam = {
                "WebSiteUrl": strWebSiteUrl,
                "ArgList": strQueryString,
                "IsAssessments": true
            }
            setIsShowOpenWebWindow(true)
        } // end of if (!window.gSession.App.InApp)
        else
        {
            // WebCallApp
            if (window.gSession.App.iOSNewGateway)
            {
                // 不使用 之前 會開下載視窗的流程，改用 開其他App的新流程   Tim23.09.07
                let strUrl = window.gConfig.DCPAssessmentUrl
                
                let intEnv = GlobalLibs.GetIntEnv(window.gSession.App.Env)

                let strParmsQueryString = "CurrentClassID=" + intClassID    // 可以將 CurrentClassID 傳過去，方便進入該Class
                strParmsQueryString += "&TimeZone=" + strTimeZoneValue
                strParmsQueryString += "&DST=" + window.gSession.Acc.Preferences.DST
                strParmsQueryString += "&LoginName=" + window.gSession.Acc.LoginName
                strParmsQueryString += "&AccountID=" + window.gSession.Acc.ID
                strParmsQueryString += "&Credential=" + window.gSession.Acc.Credential
                strParmsQueryString += "&Env=" + intEnv

                // In App
                var strWebSiteUrl = strUrl + "?" + strParmsQueryString
                console.log(COMP_NAME + "." + FUNC_NAME + " CallApp strWebSiteUrl: ", strWebSiteUrl)

                let intAction = window.gConst.ACTION_OPEN_BROWSER
                let strQueryString = "Action=" + intAction
                strQueryString += "&Credential=" + window.gSession.Acc.Credential
                strQueryString += "&BackRoute="
                strQueryString += "&Url=" + encodeURIComponent(strWebSiteUrl)

                console.log(COMP_NAME + "." + FUNC_NAME + " strQueryString: ", strQueryString)

                ClientGatewayInPackage.CallApp(strQueryString)

                // let intAction = window.gConst.ACTION_OPEN_ANOTHER_APP_BY_URL_SCHEMES

                // let strParmsQueryString = "CurrentClassID=" + intClassID     // 可以將 CurrentClassID 傳過去，方便進入該Class
                // strParmsQueryString += "&TimeZone=" + strTimeZoneValue
                // strParmsQueryString += "&DST=" + window.gSession.Acc.Preferences.DST
                // strParmsQueryString += "&ClassName=" + window.gSession.Acc.Profile.ClassName
                // strParmsQueryString += "&UserName=" + window.gSession.Acc.Profile.UserName
                // strParmsQueryString += "&LoginName=" + window.gSession.Acc.LoginName
                // strParmsQueryString += "&AccountID=" + window.gSession.Acc.ID
                // console.log(COMP_NAME + "." + FUNC_NAME + " iOSNewGateway strParmsQueryString: ", strParmsQueryString)

                // let strURL = window.gAppURLSchemes.DCPAssessment + "://?" + strParmsQueryString
                // let strQueryString = "Action=" + intAction 
                // strQueryString += "&Credential=" + window.gSession.Acc.Credential 
                // strQueryString += "&BackRoute="
                // strQueryString += "&AppUrl4Open=" + encodeURIComponent(strURL)
                // console.log(COMP_NAME + "." + FUNC_NAME + " iOSNewGateway strQueryString: ", strQueryString)
                
                // // 已有安裝 DCPAssessment App 且 可成功直接開 DCPAssessment App 時 不回傳
                // // 未安裝 DCPAssessment App時 會開啟失敗才回傳
                // // ClientGatewayInPackage.CallApp(strQueryString, window.CallAppAPI, window.gSession.App.InApp, window.gSession.App.iOSNewGateway, BackFromAppCallbackGoToDCPAssessments)
                // ClientGatewayInPackage.CallApp(strQueryString, BackFromAppCallbackGoToDCPAssessments)
            } // end of if (window.gSession.App.iOSNewGateway)
            else
            {

                // call App (DCP)
                let intAction = window.gConst.ACTION_OPEN_DCP_ASSESSMENT

                //  可以將 CurrentClassID 傳過去，方便進入該Class
                let strQueryString = "Action=" + intAction 
                strQueryString += "&Credential=" + window.gSession.Acc.Credential 
                strQueryString += "&BackRoute=" 
                strQueryString += "&CurrentClassID=" + intClassID
                strQueryString += "&TimeZone=" + strTimeZoneValue
                strQueryString += "&DST=" + window.gSession.Acc.Preferences.DST
                strQueryString += "&ClassName=" + window.gSession.Acc.Profile.ClassName 
                strQueryString += "&LoginName=" + window.gSession.Acc.LoginName 
                strQueryString += "&AccountID=" + window.gSession.Acc.ID

                console.log(COMP_NAME + "." + FUNC_NAME + " strQueryString: ", strQueryString)

                // ClientGatewayInPackage.CallApp(strQueryString, window.CallAppAPI, window.gSession.App.InApp, window.gSession.App.iOSNewGateway)
                ClientGatewayInPackage.CallApp(strQueryString)
            } // end of else
        } // end of else
    } // end of GoToAssessments

    // // remarks: 001 Tim 2023/06/19 處理 AppCallbackRef 反註冊
    // // remarks: 001 Tim 2023/09/07 開啟DCPAssessmentUrl App
    // //                             不使用 之前 會開下載視窗的流程，改用 開其他App的新流程
    // function BackFromAppCallbackGoToDCPAssessments(ReturnData)
    // {
    //     console.log(COMP_NAME + ".BackFromAppCallbackGoToDCPAssessments: ", ReturnData)

    //     if (
    //         (typeof (ReturnData) !== 'undefined') &&
    //         (ReturnData !== null) &&
    //         (typeof (ReturnData.Status) !== 'undefined') &&
    //         (ReturnData.Status !== null)
    //     )
    //     {
    //         if (parseInt(ReturnData.Status) === 2)
    //         {
    //             console.log("show download another app window")
    //             // 未安裝 DCPAssessment 打開下載畫面
    //             setShowDownloadAnotherAppWindow(true)
    //         }
    //     }
    //     // window.gSession.App.AppCallbackRef = null
    // }

    

    /*===========================================
    summary: 開啟 BCApps
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function GoToBCApps ()
    {
        console.log(COMP_NAME + ".GoToBCApps")

        setIsShowBCAppsWindows(true)
    } // end of GoToBCApps
    
    /*===========================================
    summary: 前往 Help的 連結
    remarks: 000 Tim 2021/11/04 Create
             001 Tim 2023/06/19 CallApp前 清空 AppCallbackRef
             002 Tim 2023/08/18 改寫 ClientGatewayInPackage.CallApp(
                                參數 要改用 最新版本 QueryString, CallbackFuncRef
    ===========================================*/
    function GoToHelp ()
    {
        console.log(COMP_NAME + ".GoToHelp")
        
        let strWebSiteUrl = window.gConfig.HelpUrl

        if (!window.gSession.App.InApp)
        {
            // 另開始窗
            window.open(strWebSiteUrl)
        } // end of if (!window.gSession.App.InApp)
        else
        {
            // In App
            let intAction = window.gConst.ACTION_OPEN_BROWSER;
            let strQueryString = "Action=" + intAction
            strQueryString += "&Credential=" + window.gSession.Acc.Credential
            strQueryString += "&BackRoute="
            strQueryString += "&Url=" + encodeURIComponent(strWebSiteUrl)

            // ClientGatewayInPackage.CallApp(strQueryString, window.CallAppAPI, window.gSession.App.InApp, window.gSession.App.iOSNewGateway)
            ClientGatewayInPackage.CallApp(strQueryString)
        } // end of else
    } // end of GoToHelp
    // #endregion Other Functions

    // #region Get ClassName
    /*===========================================
    summary: 取得 章節元件 Cls
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function GetChapterUnitCls(MenuType) 
    {
        let objCls = cssPrelude.divPreludeMenu

        if (MenuType !== 1)
        {
            objCls = cssPrelude.divPreludeMenuSection
        }

        return objCls
    } // end of GetChapterUnitCls

    /*===========================================
    summary: 找尋 Dom 父物件 用 ClassName
    param: 

    retruns: 
    remarks: 001 Tim 2020/11/12 Create
    ===========================================*/
    function GetParentNodeByClassName(MyNode, ClassName)
    {
        // console.log(this.xtype + ".GetParentNodeByClassName: ", MyNode, ClassName)

        let objParentNode = MyNode
        let blnFound = false

        while (!blnFound && objParentNode !== document)
        {
            if (
                (objParentNode.className !== null) &&
                (objParentNode.className !== '') &&
                (objParentNode.className.indexOf(ClassName) !== -1)
                )
            {
                blnFound = true
            }
            else
            {
                objParentNode = objParentNode.parentNode
            }
        }

        // console.log("objParentNode: ", objParentNode)
        return objParentNode
    } // end of GetParentNodeByClassName

    /*===========================================
    summary: 取得 上一頁按鈕 Cls
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function GetPrevButtonCls(StateChaptersIndex) 
    {
        let objCls = cssPrelude.btnPrev

        // 如果 過期 就 Disable
        if (StateChaptersIndex === 0)
        {
            objCls = cssPrelude.btnPrevDisable
        }

        return objCls
    } // end of GetPrevButtonCls

    /*===========================================
    summary: 取得 下一頁按鈕 Cls
    remarks: 000 Tim 2020/11/13 Create
    ===========================================*/
    function GetNextButtonCls(StateChaptersIndex, ChaptersCount) 
    {
        let objCls = cssPrelude.btnNext

        // 如果 過期 就 Disable
        if (StateChaptersIndex === ChaptersCount - 1)
        {
            objCls = cssPrelude.btnNextDisable
        }

        return objCls
    } // end of GetNextButtonCls
    // #endregion Get ClassName

    // #region Render元件   
    /*===========================================
    summary: 下一頁按鈕 顯示Component
    remarks: 000 Tim 2021/11/127 Create
    ===========================================*/
    function ComponentNextButton( {StateChaptersIndex, ChaptersCount} ) 
    {   
        return(
            <div className={GetNextButtonCls(StateChaptersIndex, ChaptersCount)} onClick={() => NextOnTapHandler()}>
                <div className={cssPrelude.btnPageText}>
                    {window.gAppUI.BTN_NextChapter}
                </div>
                <div className={cssPrelude.btnNextIcon}/>
            </div>
        )
    } // end of ComponentNextButton                
    
    /*===========================================
    summary: 頁數標題 顯示Component
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function ComponentPageTitle( {StateChaptersIndex, ChaptersCount} ) 
    {   
        let strPage = (StateChaptersIndex + 1).toString() + ' ' + window.gAppUI.LBL_Page + ' ' + ChaptersCount.toString()
        
        return(
            <div className={cssPrelude.divPageTitle}>
                {strPage}
            </div>
        )
    } // end of ComponentPageTitle

    /*===========================================
    summary: 上一頁按鈕 顯示Component
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function ComponentPrevButton( {StateChaptersIndex} ) 
    {   
        return(
            <div className={GetPrevButtonCls(StateChaptersIndex)} onClick={() => PrevOnTapHandler()}>
                <div className={cssPrelude.btnPrevIcon}/>
                <div className={cssPrelude.btnPageText}>
                    {window.gAppUI.BTN_PreviousChapter}
                </div>
            </div>
        )
    } // end of ComponentPrevButton
    // #endregion Render元件

    // #region Render
    /*===========================================
    summary: Render Settings 的顯示
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function RenderSettingsWrapper(StateIsShowSettings)
    {
        if (
            (mobjShowComponentParam !== null) &&
            (StateIsShowSettings)
            )
        {
            return(
                <Settings AuthorizedSubscription={mobjShowComponentParam.AuthorizedSubscription} 
                    CallbackRef={ComponentCallback}/>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderSettingsWrapper
    
    /*===========================================
    summary: Render 字典 視窗 的顯示
    remarks: 000 Tim 2021/11/23 Create
    ===========================================*/
    function RenderGlossaryWrapper(StateIsShowGlossary)
    {
        if (StateIsShowGlossary)
        {
            return(
                <Glossary History={props.history}
                    ButtonType={window.gButtonTypeEnum.Prelude}
                    CallbackRef={ComponentCallback}/>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderGlossaryWrapper

    /*===========================================
    summary: Render 筆記列表 視窗 的顯示
    remarks: 000 Tim 2021/11/19 Create
    ===========================================*/
    function RenderNoteListWrapper(StateIsShowNoteList)
    {
        if (StateIsShowNoteList)
        {
            return(
                <NoteList History={props.history}
                    ButtonType={window.gButtonTypeEnum.Prelude}
                    CallbackRef={ComponentCallback}/>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderNoteListWrapper

    /*===========================================
    summary: Render 資源下載視窗 的顯示
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function RenderResourceWrapper(StateIsShowResource)
    {
        if (StateIsShowResource)
        {
            return(
                <Resource CallbackRef={ComponentCallback}/>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderResourceWrapper

    /*===========================================
    summary: Render BCAppsWindows 的顯示
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function RenderBCAppsWindowsWrapper(StateIsShowBCAppsWindows)
    {
        if (StateIsShowBCAppsWindows)
        {
            return(
                <BCAppsWindows CallbackRef={ComponentCallback}/>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderBCAppsWindowsWrapper

    /*===========================================
    summary: Render OpenWebWindow 的顯示
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function RenderOpenWebWindowWrapper(StateIsShowOpenWebWindow)
    {
        if (
            (mobjShowComponentParam !== null) &&
            (StateIsShowOpenWebWindow)
            )
        {
            return(
                <OpenWebWindow WebSiteUrl={mobjShowComponentParam.WebSiteUrl}
                    ArgList={mobjShowComponentParam.ArgList}
                    IsAssessments={mobjShowComponentParam.IsAssessments}
                    CallbackRef={ComponentCallback}/>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderOpenWebWindowWrapper

    /*===========================================
    summary: Render 左邊 Tool選單 的顯示
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function RenderBottomToolMenuWrapper(StateToolMenuAnimation)
    {
        return (
            <Slide direction="up" in={StateToolMenuAnimation} 
                    timeout={250} mountOnEnter unmountOnExit>
                <div className={cssPrelude.divBottomTool}> 
                    <ToolBarBottomUnit ButtonType={window.gButtonTypeEnum.Prelude}
                        History={props.history}
                        CallbackRef={ComponentCallback}/>
                </div>
            </Slide>
        )
    } // end of RenderBottomToolMenuWrapper

    /*===========================================
    summary: Render ChapterList Content的顯示
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function RenderChapterListContentWrapper(MenuList)
    {
        let arrMenu = GenerateFlattedMenuList4Display(MenuList)

        return (
            <div className={cssPrelude.divChapterListContent}> 
                <div className={cssPrelude.divChapterListSubContent}> 
                    {arrMenu.map((MenuData, MenuIndex) =>  
                        <div key={MenuIndex} className={GetChapterUnitCls(MenuData.Type)} 
                                chapterid={MenuData.ChapterID} sectionid={MenuData.SectionID}
                                onClick={(event) => ChapterUnitOnTapHandler(event)}>
                            <div className={cssPrelude.divMenuText}>
                                {MenuData.Name}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        )
    } // end of RenderChapterListContentWrapper

    /*===========================================
    summary: Render 左邊 Tool選單 的顯示
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function RenderLeftToolMenuWrapper(StateChapterListAnimation)
    {
        return (
            <Slide direction="right" in={StateChapterListAnimation} 
                    timeout={250} mountOnEnter unmountOnExit>
                {RenderChapterListContentWrapper(marrMenu)}
            </Slide>
        )
    } // end of RenderLeftToolMenuWrapper

    /*===========================================
    summary: Render 上方 Tool選單 的顯示
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function RenderTopToolMenuWrapper(MenuList, StateChaptersIndex, StateToolMenuAnimation)
    {
        // set Title of Top Toolbar
        let strContentTitle = window.gAppUI.LBL_Chapter + ' ' + MenuList[StateChaptersIndex].Name

        return (
            <Slide direction="down" in={StateToolMenuAnimation} 
                    timeout={250} mountOnEnter unmountOnExit>
                <div className={cssPrelude.divTopTool}> 
                    <ToolBarTopUnit Title={strContentTitle}
                        ButtonType={window.gButtonTypeEnum.Prelude}
                        CallbackRef={ComponentCallback}/>
                </div>
            </Slide>
        )
    } // end of RenderTopToolMenuWrapper

    /*===========================================
    summary: Render Tool選單 的顯示
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function RenderToolMenuWrapper(StateToolMenu, StateChaptersIndex)
    {
        if (
            (StateToolMenu) &&
            (StateChaptersIndex >= 0)
            )
        {
            return (
                <div className={cssPrelude.divMask} onClick={() => MaskOnTapHandler()}>
                    {RenderTopToolMenuWrapper(marrMenu, StateChaptersIndex, toolMenuAnimation)}
                    
                    {RenderLeftToolMenuWrapper(chapterListAnimation)}

                    {RenderBottomToolMenuWrapper(toolMenuAnimation)}
                </div>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderToolMenuWrapper

    /*===========================================
    summary: Render Content 的顯示
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function RenderBottomToolWrapper(StateChaptersIndex, ChaptersCount)
    {
        if (
            (StateChaptersIndex >= 0) &&
            (ChaptersCount !== 1)
            )
        {
            return (
                <div className={cssPrelude.divBottomTool}>
                    <ComponentPrevButton StateChaptersIndex={StateChaptersIndex} />

                    <ComponentPageTitle StateChaptersIndex={StateChaptersIndex} ChaptersCount={ChaptersCount} />

                    <ComponentNextButton StateChaptersIndex={StateChaptersIndex} ChaptersCount={ChaptersCount} />
                </div>
            )   
        }
        else
        {
            return (
                <div className={cssPrelude.divBottomTool}>
                </div>
            )
        }
    } // end of RenderBottomToolWrapper

    /*===========================================
    summary: Render Content 的顯示
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function RenderContentWrapper(StateChaptersIndex, StateUpdateDataTime)
    {
        if (
            (StateChaptersIndex >= 0) &&
            (StateUpdateDataTime > 0)
            )
        {
            let strContentHtml = GetContentHtml(StateChaptersIndex)
            // 需要把裡面的文字 置換 Html碼，且轉換成 React 可以顯示    Tim20.08.06
            // https://www.npmjs.com/package/html-react-parser
            // load this Chapter

            // console.log("RenderContentWrapper strContentHtml: ", strContentHtml)

            return (
                <div ref={mrefContent} className={cssPrelude.divContent} 
                        onClick={(event) => ClickOnContentHandler(event)}
                        onTimeUpdate={(event) => BCCustomAudioTimeChange(event)}
                        onEnded={(event) => BCCustomAudioOnEnd(event)}
                        onCanPlay={(event) => BCCustomAudioCanPlay(event)}
                        onPlay={(event) => BCCustomAudioOnPlay(event)}
                        onPause={(event) => BCCustomAudioOnPause(event)}>
                    {parse(strContentHtml)}
                </div>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderContentWrapper

    /*===========================================
    summary: Render TopTool 的顯示
    remarks: 000 Tim 2021/11/11 Create
    ===========================================*/
    function RenderTopToolWrapper()
    {
        return (
            <div className={cssPrelude.divTopTool}>
                <div className={cssPrelude.btnTool} onClick={() => ToolOnTapHandler()}/>
            </div>
        )
    } // end of RenderTopToolWrapper

    // remarks: 001 Tim 2023/09/07 開啟DCPAssessmentUrl App
    //                             不使用 之前 會開下載視窗的流程，改用 開其他App的新流程
    // function RenderDownloadAnotherAppWindowWrapper()
    // {
    //     let objBlock = null
    //     if (showDownloadAnotherAppWindow)
    //     {
    //         objBlock = <DownloadAnotherAppWindow CallbackRef={DownloadAnotherAppWindowCallback} />
    //     }
    //     return objBlock
    // }

    /*===========================================
    summary: Render 主畫面 的顯示
    remarks: 000 Tim 2021/11/11 Create
    ===========================================*/
    function RenderMainWrapper()
    {
        if (!mblnIfNeed2GoToApplicationHomePage)
        {
            return (
                <>
                    <div className={cssPrelude.divMain}>
                        {RenderTopToolWrapper()}
                        
                        {RenderContentWrapper(chaptersIndex, updateDataTime)}

                        {RenderBottomToolWrapper(chaptersIndex, mintTotalChapters)}

                        {RenderToolMenuWrapper(toolMenu, chaptersIndex)}
                    </div>

                    {RenderOpenWebWindowWrapper(isShowOpenWebWindow)}
                    {RenderBCAppsWindowsWrapper(isShowBCAppsWindows)}
                    
                    {RenderSettingsWrapper(isShowSettings)}
                    {RenderGlossaryWrapper(isShowGlossary)}
                    {RenderNoteListWrapper(isShowNoteList)}
                    {RenderResourceWrapper(isShowResource)}
                    {/* {RenderDownloadAnotherAppWindowWrapper()} */}

                    <LoadingMask ShowMask={showLoadingMask} Message={loadingMaskMessage} />
                    <AlertWindow ShowAlert={showAlert} AlertObject={alertObject} HideAlertFuncRef={HideAlert} />
                    <CredentialMultiInWindow ShowCredentialMultiIn={showCredentialMultiIn} 
                        CredentialMultiInArguments={credentialMultiInArguments}/>
                </>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderMainWrapper

    // Similar to Render
    return (
        <>
            {RenderMainWrapper()}
        </>
    )
    // #endregion Render
}
export default Prelude